import { useFormSchema, useFormValues } from '../InsurancePolicyBuyForm';

export const useInitialValues = useFormValues;

export const useValidationSchema = useFormSchema;
